export default __webpack_public_path__ + "static/media/Magadhi_cf_2.4a68181b.mp3";